import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { registerWidget } from "../../uxp";
import { deriveJSONPath } from "./data-source-picker/datasource";
import { getUrlFriendlyString, hasValue } from "../../util";
import { IWidgetTemplate, IWidgetTemplatePreset } from "./common-types";

function deepMergePlain(base: any, patch: any): any {
    const out: any = { ...base };
    for (const k of Object.keys(patch || {})) {
        const pv = (patch as any)[k];
        const bv = out[k];
        if (pv && typeof pv === 'object' && !Array.isArray(pv) && bv && typeof bv === 'object' && !Array.isArray(bv)) {
            out[k] = deepMergePlain(bv, pv);
        } else {
            out[k] = pv;
        }
    }
    return out;
}

/** Apply a template preset to the current uiProps (pure — returns a new object). */
export function applyTemplatePreset(current: any, preset: IWidgetTemplatePreset): any {
    const base: any = { ...(current || {}) };
    for (const k of Object.keys(preset.seed || {})) {
        if (base[k] == null) base[k] = JSON.parse(JSON.stringify((preset.seed as any)[k]));
    }
    return deepMergePlain(base, preset.uiProps);
}

/** Templates hidden from the template selector until they have a real web
 *  rendering (mobile-app era; their web render is a stub). Remove ids as web
 *  versions ship. Existing widgets built on these still load and edit — this
 *  list only gates the "new widget" selector. */
export const WEB_STUB_TEMPLATE_IDS = ['search-widget', 'custom-ui-card'];

let cardTemplateRegister: { [id: string]: IWidgetTemplate } = {};

export function registerCardTemplate(template: IWidgetTemplate) {
    let id = getUrlFriendlyString(template.id)
    if (!template.icon) template.icon = ['fad', 'align-justify'] as IconProp
    cardTemplateRegister[id] = { ...template, id: id, isDefaultTemplate: true };

    registerWidget({
        id: id,
        widget: template.template,
        isDefaultTemplate: true, // mark this widget as a template
        configs: {
            layout: template.layout || { w: 10, h: 10 },
            props: [
                {
                    name: "uiProps",
                    label: "UI",
                    type: "json"
                }
            ],
            preLoader: template?.preLoader || 'default',
        },
        defaultProps: {
            uiProps: {},
        }

    });

}

(window as any).registerCustomWidgetTemplate = (template: IWidgetTemplate) => {
    let id = getUrlFriendlyString(template.id)
    if (!template.icon) template.icon = ['fad', 'align-justify'] as IconProp
    cardTemplateRegister[id] = { ...template, id: id, isDefaultTemplate: false };
}


export function getCardTemplates(expectedSchema?: any, exactMatch: boolean = false, query?: string, isCustomTemplates?: boolean) {
    // console.log('card templates', cardTemplateRegister, expectedSchema);
    const allCards = { ...cardTemplateRegister }
    let templates = [...Object.values(allCards)]
    templates = filterTemplates(templates, expectedSchema, exactMatch, query)

    const isDefaultTemplate = isCustomTemplates != undefined ? !isCustomTemplates : true

    const final = templates.filter(t => (t.isDefaultTemplate == isDefaultTemplate))

    // console.log('after filtered', templates);
    return final;
}

export function containsText(source: string, search: string) {
    return (source?.indexOf(search) !== -1)
}
export function filterTemplates(templates: IWidgetTemplate[], expectedSchema?: any, exactMatch: boolean = false, query?: string) {
    // filter by schema
    console.log('custom_widgets templates_____', templates)
    let _templates = [...templates]

    if (!!expectedSchema) {
        _templates = _templates.filter(t => {
            try {
                let path = deriveJSONPath(expectedSchema, {}, t.expectedSchema)
                if (exactMatch) {
                    return path == '$';
                }
                if (!!path) return true
            } catch (error) { }
            return false
        })
    }

    // filter by query
    if (hasValue(query)) {
        _templates = _templates.filter(f => {
            return (containsText(f.id, query) || containsText(f.name, query) || containsText(f.description, query))
        })
    }
    return _templates
}

export function findCardTemplate(id: string) {
    // extract template details
    let templateId = id
    if (id?.startsWith('user-template')) {
        const parts = id.split('@@@')
        templateId = parts[1]
    }

    let inst = cardTemplateRegister[templateId]
    if (inst) return inst
    return null
}

export function getUserTemplateKeyFromId(id: string) {
    if (id?.startsWith('user-template')) {
        const parts = id.split('@@@')
        return parts[2] || null
    }
    return null
}

/**
 * Mobile card templates were removed in the v5 migration (Phase 6). These two
 * functions are retained as exported no-op stubs because third-party widget
 * bundles built against older versions may still call them at load time. They
 * warn once (to aid diagnosis) and otherwise do nothing / return nothing.
 */
let _warnedMobileTemplatesRemoved = false;
function warnMobileTemplatesRemovedOnce() {
    if (_warnedMobileTemplatesRemoved) return;
    _warnedMobileTemplatesRemoved = true;
    console.warn(
        '[widget-designer] Mobile card templates are no longer supported and were removed in v5. ' +
        'registerMobileCardTemplate / getMobileCardTemplates are now no-ops.'
    );
}

export function registerMobileCardTemplate(_template: IWidgetTemplate) {
    warnMobileTemplatesRemovedOnce();
    // no-op: mobile card templates are not registered anymore.
}


export function getMobileCardTemplates(_expectedSchema?: any, _exactMatch: boolean = false, _query?: string, _isCustomTemplates?: boolean): IWidgetTemplate[] {
    warnMobileTemplatesRemovedOnce();
    return [];
}
